import { httpClient } from '../http-client/http-client';
import { apiConstants } from './apiConstants';

const IsTenantAvailable = (tenancyName) => {
  const url = apiConstants.IsTenantAvailable;

  const body = {
    tenancyName,
  };

  return httpClient.post(url, body).then(result => result.data);
};

export { IsTenantAvailable };
